import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';
import { PageHeaderProvider } from '@nexdel/core/hooks/use-page-header';

export function AppLayout() {
  return (
    <PageHeaderProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0 h-full app-content pl-4">
          <AppHeader />
          <main className="flex-1 overflow-hidden min-h-0">
            <Outlet />
          </main>
        </div>
      </div>
    </PageHeaderProvider>
  );
}
